"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPackageUniqueKey = getPackageUniqueKey;
exports.default = buildPackageOption;
function getPackageUniqueKey(packageId, duration, roomRateId) {
    return `P:${packageId}D:${duration}R:${roomRateId}`;
}
/**
 * Counts the total occupants across all occupancy groups
 * @param occupancies - Array of occupancy groups
 * @returns Object with total counts for adults, children, infants, and teenagers
 */
function countOccupants(occupancies) {
    return occupancies.reduce((acc, occupancy) => {
        return {
            adults: acc.adults + (occupancy.adults || 0),
            children: acc.children + (occupancy.children || 0),
            infants: acc.infants + (occupancy.infants || 0),
            teenagers: acc.teenagers + (occupancy.teenagers || 0),
        };
    }, {
        adults: 0,
        children: 0,
        infants: 0,
        teenagers: 0,
    });
}
function isReservationAvailableForRoom(occupancy, capacities, offer) {
    if (offer.property?.useDynamicOccupancy && !capacities.length) {
        return true;
    }
    const transformedOccupants = countOccupants([occupancy]);
    return capacities.some(cap => transformedOccupants.adults <= cap.adults &&
        transformedOccupants.teenagers <= (cap.teenagers || 0) &&
        transformedOccupants.children <= cap.children &&
        transformedOccupants.infants <= cap.infants);
}
function buildPackageOption(serverPackage, leHotelOffer, serverOptions, occupancy, availableRoomsByPackage) {
    // Find the corresponding option for this package
    const serverOption = serverOptions.find(opt => opt.fkPackageId === serverPackage.id || opt.fkPackageId === serverPackage.lePackageId);
    if (!serverOption) {
        throw new Error(`No option found for package ${serverPackage.id || serverPackage.lePackageId} on given offer`);
    }
    // Get room type, rate and plan
    const roomType = leHotelOffer.roomTypes[serverOption.fkRoomTypeId];
    const roomRate = leHotelOffer.roomRates[serverOption.fkRoomRateId];
    const ratePlan = leHotelOffer.ratePlans[serverOption.fkRatePlanId];
    // Create the package with all properties
    const packageWithMetadata = {
        ...serverPackage,
        uniqueKey: getPackageUniqueKey(serverPackage.id || serverPackage.lePackageId, serverOption.duration, serverOption.fkRoomRateId),
        roomType,
        roomRate,
    };
    // Calculate basic pricing and availability
    const basePrice = serverOption.price || 0;
    const surcharge = serverOption.surcharge || 0;
    const extraGuestsSurcharge = 0; // Default for now, could be calculated if needed
    const hotelPrice = basePrice + surcharge + extraGuestsSurcharge;
    // Basic availability check
    const hotelAvailable = !!serverOption.price && availableRoomsByPackage[serverOption.fkPackageId] > 0;
    // Capacity validation
    const roomCapacities = roomRate.capacities;
    const isCapacityValid = occupancy.every(occupants => isReservationAvailableForRoom(occupants, roomCapacities, leHotelOffer));
    // Refundable check based on cancellation policy
    const refundable = ratePlan?.cancellationPolicy?.type !== 'non-refundable';
    return {
        package: packageWithMetadata,
        hotelPrice,
        hotelAvailable,
        capacityValid: isCapacityValid,
        refundable,
    };
}
